import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../service/auth-service";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";

const authService = new AuthService();

await loadDictionary('auth-login-page');

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const handleSubmit = useCallback(() => {
        authService.login(username, password).then(check => {
            if(check) {
                navigate("/");
            }
        }).catch(error => {
            console.error(error);            
        });
    }, [username, password, navigate]);

    return (
        <div className="h-100 w-100 pt-5 bg-body-tertiary">
            <div className="py-5 px-md-5 px-3 mx-auto bg-body border border-light-subtle" style={{width: "400px"}}>
                <h4 className="mb-5 text-center ">{i18n.t("auth-login-page.welcome_message")}</h4>
                <form method="post" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
                    <div className="mb-3">
                        <input type="text" name="username" id="Username" className="form-control" dir="ltr" placeholder={i18n.t("auth-login-page.username")} value={username} onChange={e => {setUsername(e.target.value)}} />
                    </div>
                    <div className="mb-4">
                        <input type="password" name="password" id="Password" className="form-control" dir="ltr" placeholder={i18n.t("auth-login-page.password")} value={password} onChange={e => {setPassword(e.target.value)}} />
                    </div>
                    <div className="text-center">
                        <button type="submit" className="btn btn-primary">{i18n.t("auth-login-page.submit_button")}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginPage;